module.exports = __webpack_public_path__ + "assets/merriweather-italic.ae0f48621e097b836b7790107eb566c6426dc7b8ad9d4125526c79cb75172675.woff";